import { render, staticRenderFns } from "./PushList.vue?vue&type=template&id=0c38af1a&scoped=true"
import script from "./PushList.vue?vue&type=script&lang=js"
export * from "./PushList.vue?vue&type=script&lang=js"
import style0 from "./PushList.vue?vue&type=style&index=0&id=0c38af1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38af1a",
  null
  
)

export default component.exports